import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { endpoints } from '@/API/endpoints';
import { useApi } from '@/hooks/useApi/useApi';

import ProjectDetails from './project-details/ProjectDetails';
import ProjectInfo from './project-info/ProjectInfo';
import classes from './ProjectCase.module.scss';

const ProjectCase = () => {
	const [permitForRedakt, setPermitForRedact] = useState<boolean>();

	const { apiGet } = useApi();
	const navigate = useNavigate();

	const projectId = globalThis.location.pathname.split('/projects/')[1];

	useEffect(() => {
		const fetchPermit = async () => {
			const res = await apiGet(`${endpoints.permit}project/${projectId}`);
			if (res.status === 404) {
				navigate('/404');
			} else if (res.data.can_edit_project) {
				setPermitForRedact(true);
			} else {
				setPermitForRedact(false);
			}
		};
		fetchPermit();
	}, []);

	// eslint-disable-next-line unicorn/no-negated-condition
	return permitForRedakt !== undefined ? (
		<div className={classes.container}>
			<ProjectDetails redaktPermit={permitForRedakt} />
			<ProjectInfo redaktPermit={permitForRedakt} />
		</div>
	) : null;
};

export default ProjectCase;
